var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "form-accordion",
        { attrs: { title: _vm.pageTitle, isTitleUpperCase: false } },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("label", { attrs: { for: "checkbox-group-1" } }, [
                    _vm._v(_vm._s(_vm.$t("common.global.client"))),
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox-group", {
                    attrs: {
                      id: "checkbox-group-1",
                      disabled: _vm.readonly,
                      options: _vm.listVerifClientSSL,
                      stacked: "",
                    },
                    model: {
                      value: _vm.selectedVerif,
                      callback: function ($$v) {
                        _vm.selectedVerif = $$v
                      },
                      expression: "selectedVerif",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("label", { attrs: { for: "checkbox-group-2" } }, [
                    _vm._v(_vm._s(_vm.$t("common.global.server"))),
                  ]),
                  _vm._v(" "),
                  _c("b-form-checkbox-group", {
                    attrs: {
                      id: "checkbox-group-2",
                      disabled: _vm.readonly,
                      options: _vm.listVerifServerSSL,
                      stacked: "",
                    },
                    model: {
                      value: _vm.selectedVerif,
                      callback: function ($$v) {
                        _vm.selectedVerif = $$v
                      },
                      expression: "selectedVerif",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.global.encryption_and_signature"),
            isTitleUpperCase: false,
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "encryption" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.global.encryption")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass: "form-control",
                    attrs: { disabled: "", id: "encryption" },
                  },
                  [_c("option", [_vm._v(_vm._s(_vm.$t("common.global.no")))])]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "signature" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.global.signature")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    staticClass: "form-control",
                    attrs: { disabled: "", id: "signature" },
                  },
                  [_c("option", [_vm._v(_vm._s(_vm.$t("common.global.no")))])]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }